import { api } from "#app/http/api";
import { PermissionDto } from "#modules/permissions/infra/Permission.dto";
import { ApiError } from "#shared/infra/apiError";

export const fetchPermissions = async (): Promise<PermissionDto[]> => {
  const response = await api.permissions.findAll.query();

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to fetch permissions", response.status, response.body);
};
